
/* injects from baggage-loader */

'use strict';

import fileManagementFiltersTpl from '!!file-loader?name=templates/[name].[ext]!./fileManagementFilters.html';

/**
 *	Directive used for manipulate the HTML DOM elements inside the fileManagementFiltersSelect component
 * @returns
 */
function fileManagementFiltersComponent() {

	/**
	 * Directive definition.
	 */
	const directive = {
		restrict: 'E',
		templateUrl: fileManagementFiltersTpl,
		controller: FileManagementFiltersController,
		controllerAs: 'fileManagementFiltersvm',
		scope: {
			type: '=',
			status: '=',
			initialDate: '=',
			finalDate: '='
		},
		bindToController: true
	};

	return directive;

	/**
	 * Controller used by fileManagementFilters directive
	 */
	function FileManagementFiltersController(fileManagementFiltersConstant, utilitiesConstant, restClientServices, utilitiesFactory) {
		'ngInject';

		/**
		 * Scope for manipulated data in HTML DOM elements.
		 */
		let vm = this;

		vm.fileManagementFiltersConstant = fileManagementFiltersConstant;

		vm.today = new Date();
		vm.limitDate = new Date();
		vm.limitDate.setDate(vm.today.getDate() - fileManagementFiltersConstant.LIMIT_DATE);

		vm.types = [];
		vm.statuses = [];

		/**
		 * Filter report types by name and code
		 * @param {*} searchText
		 */
		vm.searchType = searchText => vm.types.filter(type => _.includes(type.name.toLowerCase(), searchText.toLowerCase()) || _.includes(type.code, searchText));

		/**
		 * Filter process status types by name and code
		 * @param {*} searchText
		 */
		vm.searchStatus = searchText => vm.statuses.filter(status => _.includes(status.name.toLowerCase(), searchText.toLowerCase()) || _.includes(status.code, searchText));

		(function () {
			/**
			 * Get the report and process status types available on the server
			 */
			const typesURL = utilitiesConstant.URL_ENDPOINT.concat(utilitiesConstant.URL_API_METHOD.TYPES);
			const statusesURL = utilitiesConstant.URL_ENDPOINT.concat(utilitiesConstant.URL_API_METHOD.PROCESS_STATUSES);
			restClientServices.queryService(typesURL)
				.then(response => {
					vm.types = response;
				},
				() => {
					utilitiesFactory.showErrorMessage(utilitiesConstant.MSG_ERROR);
				});

			restClientServices.queryService(statusesURL)
				.then(response => {
					vm.statuses = response;
				},
				() => {
					utilitiesFactory.showErrorMessage(utilitiesConstant.MSG_ERROR);
				});
		})();
	}
}

export default fileManagementFiltersComponent;



// WEBPACK FOOTER //
// ./src/app/core/components/fileManagementFilters/fileManagementFilters.directive.js